import { Reveal } from "./Reveal";

export const Eyebrow = ({ children, dark = false, className = "" }) => (
  <span className={`eyebrow ${dark ? "text-lime" : "text-sageDeep"} ${className}`}>
    <span className={`h-1.5 w-6 rounded-full ${dark ? "bg-lime" : "bg-ink"}`} aria-hidden />
    {children}
  </span>
);

export const SectionHead = ({ eyebrow, title, intro, dark = false, className = "", id }) => (
  <div className={`max-w-3xl ${className}`}>
    {eyebrow && <Reveal><Eyebrow dark={dark}>{eyebrow}</Eyebrow></Reveal>}
    <Reveal delay={0.05}>
      <h2 id={id} className={`h2 mt-5 ${dark ? "text-white" : "text-ink"}`}>{title}</h2>
    </Reveal>
    {intro && (
      <Reveal delay={0.1}>
        <p className={`mt-5 text-base md:text-lg leading-relaxed ${dark ? "text-white/75" : "text-ink/75"}`}>{intro}</p>
      </Reveal>
    )}
  </div>
);
